(() => {
  const STORAGE_KEY = 'medgluv_buyer_mode';
  const VALID_MODES = new Set(['standard', 'institutional']);
  const root = document.documentElement;
  const body = document.body;

  const isB2B = body?.dataset.medgluvB2b === 'true';

  const institutionalEntryPaths = new Set([
    '/pages/government-gpo',
    '/pages/government-purchasing',
    '/pages/contract-customer-information'
  ]);

  const specialtyIndustryPaths = new Set([
    '/pages/aesthetics-salon',
    '/pages/automotive-mechanical',
    '/pages/tattoo-piercing',
    '/pages/funeral-home-mortuary-care'
  ]);

  const ambiguousIndustryPaths = new Set([
    '/pages/healthcare-clinical',
    '/pages/dental',
    '/pages/ems-emergency-medical',
    '/pages/laboratory',
    '/pages/childcare-elder-care',
    '/pages/food-service',
    '/pages/janitorial-sanitation',
    '/pages/pest-control-extermination'
  ]);

  const dualPathIndustryPaths = new Set([
    '/pages/government-public-safety'
  ]);

  const normalizePath = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return url.pathname.replace(/\/$/, '') || '/';
    } catch (error) {
      return '';
    }
  };

  const isInstitutionalEntryPath = () => institutionalEntryPaths.has(normalizePath(window.location.href));

  const readMode = () => {
    if (isB2B) return 'institutional';
    if (isInstitutionalEntryPath()) return 'institutional';
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      return VALID_MODES.has(saved) ? saved : 'standard';
    } catch (error) {
      return 'standard';
    }
  };

  const persistMode = (mode) => {
    if (!VALID_MODES.has(mode) || isB2B) return;
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
    } catch (error) {}
  };

  const applyMode = (mode, { persist = false } = {}) => {
    const effectiveMode = isB2B ? 'institutional' : (VALID_MODES.has(mode) ? mode : 'standard');

    root.classList.toggle('medgluv-mode-institutional', effectiveMode === 'institutional');
    root.classList.toggle('medgluv-mode-standard', effectiveMode === 'standard');
    root.dataset.medgluvBuyerMode = effectiveMode;

    if (persist) persistMode(effectiveMode);

    document.dispatchEvent(new CustomEvent('medgluv:buyer-mode-change', {
      detail: { mode: effectiveMode, isB2B }
    }));
  };

  if (!isB2B && isInstitutionalEntryPath()) {
    persistMode('institutional');
  }

  applyMode(readMode());

  document.addEventListener('click', (event) => {
    const setter = event.target.closest('[data-medgluv-set-mode]');
    if (setter) {
      const requestedMode = setter.dataset.medgluvSetMode;
      if (VALID_MODES.has(requestedMode) && !isB2B) {
        applyMode(requestedMode, { persist: true });
      }
      return;
    }

    const switcher = event.target.closest('[data-medgluv-switch-standard]');
    if (switcher && !isB2B) {
      event.preventDefault();
      applyMode('standard', { persist: true });

      const destination = switcher.getAttribute('data-medgluv-standard-url') || '/collections/all-products';
      window.location.href = destination;
    }
  });

  const hasChosenBuyerMode = () => {
    if (isB2B) return true;

    try {
      return VALID_MODES.has(window.localStorage.getItem(STORAGE_KEY));
    } catch (error) {
      return false;
    }
  };

  const closeHomeShopPrompt = () => {
    document.querySelector('[data-medgluv-home-shop-modal]')?.remove();
  };

  const homeShopPrompt = (destination) => {
    closeHomeShopPrompt();

    const modal = document.createElement('div');
    modal.className = 'medgluv-specialty-modal';
    modal.setAttribute('data-medgluv-home-shop-modal', '');

    modal.innerHTML = `
      <div class="medgluv-specialty-modal__backdrop" data-medgluv-home-shop-close></div>

      <div
        class="medgluv-specialty-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="MedgluvHomeShopTitle"
      >
        <button
          class="medgluv-specialty-modal__close"
          type="button"
          aria-label="Close"
          data-medgluv-home-shop-close
        >×</button>

        <span class="medgluv-specialty-modal__eyebrow">
          Choose How You Buy
        </span>

        <h2 id="MedgluvHomeShopTitle">
          How would you like to shop?
        </h2>

        <p>
          Choose the purchasing experience that fits your organization.
        </p>

        <div class="medgluv-specialty-modal__actions">
          <button
            type="button"
            class="medgluv-specialty-modal__primary"
            data-medgluv-home-shop-institutional
          >
            Government / GPO Purchasing
          </button>

          <button
            type="button"
            class="medgluv-specialty-modal__secondary"
            data-medgluv-home-shop-standard
          >
            Standard Online Shopping
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    modal
      .querySelector('[data-medgluv-home-shop-institutional]')
      ?.addEventListener('click', () => {
        applyMode('institutional', { persist: true });
        window.location.href = destination;
      });

    modal
      .querySelector('[data-medgluv-home-shop-standard]')
      ?.addEventListener('click', () => {
        applyMode('standard', { persist: true });
        window.location.href = destination;
      });

    modal
      .querySelectorAll('[data-medgluv-home-shop-close]')
      .forEach((element) => {
        element.addEventListener('click', closeHomeShopPrompt);
      });

    modal
      .querySelector('[data-medgluv-home-shop-institutional]')
      ?.focus();
  };

  document.addEventListener(
    'click',
    (event) => {
      if (
        window.location.pathname !== '/' ||
        isB2B ||
        hasChosenBuyerMode()
      ) {
        return;
      }

      const shopByGloveLink = event.target.closest(
        '.shop-glove-type__card'
      );

      if (!shopByGloveLink) return;

      event.preventDefault();
      event.stopPropagation();

      homeShopPrompt(shopByGloveLink.href);
    },
    true
  );

  const SPECIALTY_SESSION_KEY = 'medgluv_specialty_mode_choice';

  const closeSpecialtyPrompt = () => {
    document.querySelector('[data-medgluv-specialty-modal]')?.remove();
  };

  const specialtyPrompt = (destination) => {
    closeSpecialtyPrompt();
    const modal = document.createElement('div');
    modal.className = 'medgluv-specialty-modal';
    modal.setAttribute('data-medgluv-specialty-modal', '');
    modal.innerHTML = `
      <div class="medgluv-specialty-modal__backdrop" data-medgluv-specialty-close></div>
      <div class="medgluv-specialty-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="MedgluvSpecialtyTitle">
        <button class="medgluv-specialty-modal__close" type="button" aria-label="Close" data-medgluv-specialty-close>×</button>
        <span class="medgluv-specialty-modal__eyebrow">Purchasing Mode</span>
        <h2 id="MedgluvSpecialtyTitle">You’re still viewing Government / GPO purchasing.</h2>
        <p>Shopping for a business or specialty trade instead? Switch to Standard Shopping to see normal online buying options.</p>
        <div class="medgluv-specialty-modal__actions">
          <button type="button" class="medgluv-specialty-modal__primary" data-medgluv-specialty-standard>Switch to Standard Shopping</button>
          <button type="button" class="medgluv-specialty-modal__secondary" data-medgluv-specialty-continue>Continue Government / GPO</button>
        </div>
      </div>`;
    document.body.appendChild(modal);

    modal.querySelector('[data-medgluv-specialty-standard]')?.addEventListener('click', () => {
      try { window.sessionStorage.setItem(SPECIALTY_SESSION_KEY, 'standard'); } catch (error) {}
      applyMode('standard', { persist: true });
      window.location.href = destination;
    });

    modal.querySelector('[data-medgluv-specialty-continue]')?.addEventListener('click', () => {
      try { window.sessionStorage.setItem(SPECIALTY_SESSION_KEY, 'institutional'); } catch (error) {}
      window.location.href = destination;
    });

    modal.querySelectorAll('[data-medgluv-specialty-close]').forEach((el) => {
      el.addEventListener('click', closeSpecialtyPrompt);
    });

    const first = modal.querySelector('[data-medgluv-specialty-standard]');
    first?.focus();
  };

  document.addEventListener('click', (event) => {
    const industryLink = event.target.closest('a[href]');
    if (!industryLink || isB2B) return;

    const path = normalizePath(industryLink.href);
    const isSpecialty = specialtyIndustryPaths.has(path);
    const isAmbiguous = ambiguousIndustryPaths.has(path);
    const isDualPath = dualPathIndustryPaths.has(path);

    if (!isSpecialty && !isAmbiguous && !isDualPath) return;

    if (isDualPath) return;

    if (!hasChosenBuyerMode()) {
      if (isSpecialty) {
        applyMode('standard', { persist: true });
        return;
      }

      if (isAmbiguous) {
        event.preventDefault();
        event.stopPropagation();
        homeShopPrompt(industryLink.href);
      }

      return;
    }

    if (!isSpecialty || readMode() !== 'institutional') return;

    let remembered = null;
    try { remembered = window.sessionStorage.getItem(SPECIALTY_SESSION_KEY); } catch (error) {}

    if (remembered === 'institutional') return;

    if (remembered === 'standard') {
      applyMode('standard', { persist: true });
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    specialtyPrompt(industryLink.href);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeHomeShopPrompt();
      closeSpecialtyPrompt();
    }
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_KEY || isB2B) return;
    applyMode(readMode());
  });

  window.MedgluvBuyerMode = {
    getMode: readMode,
    setMode(mode) {
      applyMode(mode, { persist: true });
    },
    isB2B
  };
})();
